import { PlannerEcsSystem } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
import CustomSlidingDoorComponent from '../components/CustomSlidingDoorComponent';
/**
 * This system removes the CustomSlidingDoorComponent and OutlinedComponent for all
 * custom sliding doors when the entity gets unselected
 */
export class CustomSlidingDoorSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'CustomSlidingDoorSystem', ComponentIds.SELECTED_COMPONENT_ID);
    }
    onAdd() { }
    onUpdate() { }
    onRemove(entity) {
        if (entity.hasComponent(CustomSlidingDoorComponent.id)) {
            const customSlidingDoors = this.coreApi.entities.getByComponent(CustomSlidingDoorComponent.id);
            customSlidingDoors.forEach(door => {
                door.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
                door.removeComponent(CustomSlidingDoorComponent.id);
            });
        }
    }
}
//# sourceMappingURL=CustomSlidingDoorSystem.js.map